import axios from 'axios';
import {actionTypes} from '../reducers/OrderFilesReducer';
import {downloadFile} from '../../../../../utils/downloadFile';

export const GET_FILE_LIST = '/ordersFiles/getFileList';
export const UPLOAD_FILE = '/ordersFiles/uploadFile';
export const DOWNLOAD_FILE = '/ordersFiles/getFile';
export const DELETE_FILE = '/ordersFiles/deleteFile';
export const UPDATE_FILE_TYPE = '/ordersFiles/updateFileType';
export const VALIDATE_FILE_NAME = '/ordersFiles/validateFileName';
export const UPDATE_FILE_NAME = '/ordersFiles/updateFileName';


export const getFileList = orderID => dispatch => {
  const data = {orderID: parseInt(orderID, 10)};

  return axios.post(GET_FILE_LIST, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error();
      const {fileList} = body;

      dispatch({
        type: actionTypes.orderFileListFetched,
        payload: {orderFileList: fileList},
      });
      return fileList || [];
    })
    .catch((err) => {
      err.clientMessage = 'Can\'t find data';
      dispatch({
        type: actionTypes.catchError,
        payload: err,
      });
    });
};

export const uploadFile = (fileToSave, orderID, orderFileTypeID, fileName, payload = {}) => {
  try {
    const formData = new FormData();
    formData.append('fileToSave', fileToSave);
    formData.append('orderID', orderID);
    formData.append('fileName', fileName);
    formData.append('orderFileTypeID', orderFileTypeID);
    Object.keys(payload).forEach(key => {
      formData.append(`${key}`, payload[key]);
    });

    return axios.post(UPLOAD_FILE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  } catch (err) {
    console.error('uploadFile returns error:');
    console.error(err);
  }
};

export const getFile = ({orderID, fileName}) => (/*dispatch*/) => {
  const data = {
    orderID: parseInt(orderID, 10),
    fileName: fileName
  };

  return axios.post(DOWNLOAD_FILE, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error();

      try {
        if (body?.file) {
          downloadFile(`data:;base64,${body.file}`, fileName);
        }
      } catch (exc) {
        console.error('Save Blob method failed with the following exception.');
        console.error(exc);
      }

      return body.file;
    })
    .catch((err) => {
      console.error('getFile returns error:');
      console.error(err);
    });
};

export const getFilePreview = ({orderID, fileName}) => {
  const data = {
    orderID: parseInt(orderID, 10),
    fileName: fileName
  };

  return axios.post(DOWNLOAD_FILE, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error();

      return body?.file ? body.file : '';
    })
    .catch((err) => {
      console.error('getFilePreview returns error:');
      console.error(err);
    });
};

export const deleteFile = ({orderID, fileID, fileName}) => (/*dispatch*/) => {
  const data = {
    orderID: parseInt(orderID, 10),
    fileID: parseInt(fileID, 10),
    fileName,
  };

  return axios.post(DELETE_FILE, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error();

      return body;
    })
    .catch((err) => {
      console.error('deleteFile returns error:');
      console.error(err);
    });
};

export const updateFileType = async (fileID, fileTypeID) => {
  try {
    const data = {
      fileID: parseInt(fileID, 10),
      fileTypeID: parseInt(fileTypeID, 10),
    };

    const response = await axios.post(UPDATE_FILE_TYPE, data);
    const {body, errorCode} = response.data;
    if (errorCode < 0) throw new Error();

    return body;
  } catch (err) {
    console.error('deleteFile returns error:');
    console.error(err);
  }
};

export const updateFileName = async (orderID, fileID, fileName) => {
  const data = {
    orderID: parseInt(orderID, 10),
    fileID: parseInt(fileID, 10),
    fileName,
  };

  const response = await axios.post(UPDATE_FILE_NAME, data);
  const {body, errorCode} = response.data;
  if (errorCode < 0) throw new Error();

  return body;
};

export const validateFileName = async (orderID, fileName) => {
  const data = {
    orderID: parseInt(orderID, 10),
    fileName,
  };

  const response = await axios.post(VALIDATE_FILE_NAME, data);
  const {body, errorCode} = response.data;
  if (errorCode < 0) throw new Error();

  return body;
};

